export const HttpErrors = {
  BadRequest: 400,
  UnprocessableEntity: 422,
  FailedDependency: 424,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
};
